import { useState } from "react";
import { HTTPMethods } from "../../../../../yoello-lib/modules/API/API";
import { useAPIV2 } from "../../../../../yoello-lib/modules/API2/useAPIv2";
import { toLocalDate } from "../../../../../yoello-lib/modules/utils/TimeConversion";
import APIExtensionsv2 from "../../../../../yoello-lib/modules/API2/APIDefs";
import { useTranslation } from "react-i18next";
import useSendSnackbar from "../../../../../hooks/useSendSnackbar";
import { ActionEnum } from "./type";

const useCheckUserStatus = (onClose?: Function) => {
  const { t } = useTranslation();
  const [userStatus, setUserStatus] = useState<string | undefined>();
  const [CreatedOn, setCreatedOn] = useState<string | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [action, setAction] = useState<string | undefined>();

  const { sendSnackbar } = useSendSnackbar();

  const { callAPI } = useAPIV2(APIExtensionsv2.userStatus, {
    onMountDisabled: true,
  });
  const onClear = () => {
    setUserStatus(undefined);
    setCreatedOn(undefined);
  };
  const onSetNewPassword = () => {
    setAction(ActionEnum.setNewPassword);
  };
  const onSearch = (data: any) => {
    setError("");
    setAction(ActionEnum.search);
    getUserStatus(data.email);
  };

  const getUserStatus = (email: string) => {
    if (email === undefined || email === "") return;
    setIsLoading(true);
    callAPI(HTTPMethods.GET, {
      query: "users",
      params: { email: email },
      apiVersion: "cognito",
    })
      .then(({ data, isSuccessful }) => {
        if (isSuccessful === true) {
          const response: any = data;
          localStorage.setItem("cognito_id", response.cognito_id);
          setUserStatus(response.status);
          setCreatedOn(toLocalDate(response.created_on, "MM/DD/YYYY"));
        }
        if (isSuccessful === false) {
          setError(t("checkUserStatus.form.emailNotFound"));
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setError(t("checkUserStatus.errors.general"));
        setIsLoading(false);
      });
  };
  const setNewPassword = (email: string) => {
    setIsLoading(true);
    callAPI(HTTPMethods.POST, {
      query: "users/reset-password",
      apiVersion: "cognito",
      body: {
        email: email,
        cognito_id: localStorage.getItem("cognito_id"),
      },
    })
      .then((results) => {
        if (results.isSuccessful === true) {
          sendSnackbar("checkUserStatus.form.success", "success");
          onClose && onClose();
        }
        if (results.isSuccessful === false) {
          sendSnackbar("checkUserStatus.errors.general", "error");
        }
        setIsLoading(false);
      })
      .catch((error) => {
        sendSnackbar("checkUserStatus.errors.general", "error");

        setIsLoading(false);
      });
  };
  const onSubmit = async ({ email }: any) => {
    if (action === ActionEnum.setNewPassword) setNewPassword(email);
  };

  return {
    isLoading,
    userStatus,
    CreatedOn,
    error,
    onSubmit,
    onSetNewPassword,
    onClear,
    onSearch,
  };
};

export default useCheckUserStatus;
